const DOCUMENT = 'ADD_PROMOCODE_';

const actions = {
  LOAD_PROMOCODES_SUCCESS: DOCUMENT + 'LOAD_PROMOCODES_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  ADD_PROMOCODE: DOCUMENT + 'ADD_PROMOCODE',
  PROMOCODE_SAVE: DOCUMENT + 'PROMOCODE_SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',

  loadPromoCodesDataSuccess: data => ({
    type: actions.LOAD_PROMOCODES_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  addPromoCode: data => ({
    type: actions.ADD_PROMOCODE,
    payload: data,
  }),

  promoCodeSave: data => ({
    type: actions.PROMOCODE_SAVE,
    payload: data,
  }),

  saveSuccess: () => ({
    type: actions.SAVE_SUCCESS,
  }),
};

export default actions;
